import axios from "axios";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import Loading from "../../components/loading/Loading";

function Edituser() {
  const [loading, setLoading] = useState();
  const { id } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();
  const [title, setTitle] = useState();
  const sizeImage = 1000000;

  const [add, setAdd] = useState({
    name: "",
    phone: "",
    email: "",
    birthday: false,
    since: false,
    expired: false,
    active: false,
    address: "",
    password: "",
    gender: "male",
    point: 0,
  });

  //Get Data
  const getData = async () => {
    const result = await axios.get(`https://mobile.amospa.com/users/${id}`);
    setAdd(result.data.data[0]);
    setData(result.data.data[0]);
  };

  const [image, setImage] = useState("");

  const updateMember = async () => {
    const update = new FormData();
    update.append("name", add.name);
    update.append("phone", add.phone);
    update.append("email", add.email);
    update.append("birthday", add.birthday);
    update.append("since", add.since);
    update.append("expired", add.expired);
    update.append("active", add.active);
    update.append("password", add.password);
    update.append("gender", add.gender);
    update.append("point", add.point);

    update.append("image", image);

    if (image.size > sizeImage) {
      setTitle("Image size is too Big, Maximum size 1MB");
      setModalShow(true);
    } else if (
      add.name !== data.name ||
      add.email !== data.email ||
      add.phone !== data.phone ||
      add.address !== data.address ||
      add.birthday !== data.birthday ||
      add.password !== data.password ||
      image !== data.image
    ) {
      setLoading(true);
      await axios.put(`https://mobile.amospa.com/users/${id}`, update);
      setLoading(false);
      setTitle("Update Success");
      setModalShow(true);
    } else {
      setTitle("No changes");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/users-mobile");
  };

  useState(() => {
    getData();
  }, []);
console.log('data', data);
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="wrapper-add-user">
                  <div className="wrapper-edit-image">
                    <div className="header-edit-image">
                      <h5 className="m-0">Update Data User</h5>
                    </div>
                    <div className="data-user">
                      <div className="wrapper-data">
                        <label>Name</label>
                        <input
                          type="text"
                          name="name"
                          defaultValue={data?.name}
                          onChange={(e) =>
                            setAdd({ ...add, name: e.target.value })
                          }
                        />
                      </div>
                      <div className="wrapper-data">
                        <label>Email Address</label>
                        <input
                          type="text"
                          name="email"
                          defaultValue={data?.email}
                          onChange={(e) =>
                            setAdd({ ...add, email: e.target.value })
                          }
                        />
                      </div>
                      <div className="wrapper-data">
                        <label>Phone</label>
                        <input
                          type="text"
                          name="phone"
                          defaultValue={data?.phone}
                          onChange={(e) =>
                            setAdd({ ...add, phone: e.target.value })
                          }
                        />
                      </div>
                      <div className="wrapper-data">
                        <label>Home Address</label>
                        <input
                          type="text"
                          name="email"
                          defaultValue={data?.address}
                          onChange={(e) =>
                            setAdd({ ...add, address: e.target.value })
                          }
                        />
                      </div>
                      <div className="wrapper-data">
                        <label>Gender</label>
                        <select
                          name="gender"
                          onChange={(e) =>
                            setAdd({ ...add, gender: e.target.value })
                          }
                        >
                          <option value={data?.gender}>{data?.gender}</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </select>
                      </div>
                      <div className="wrapper-data">
                        <label>Date of Birth</label>
                        <input
                          type="date"
                          name="birthday"
                          defaultValue={data?.birthday}
                          onChange={(e) =>
                            setAdd({ ...add, birthday: e.target.value })
                          }
                        />
                      </div>
                      <div className="wrapper-data">
                        <label>
                          Image (Max 1MB)
                          <span className="text-danger ms-2">
                            {image && image.size > sizeImage
                              ? "Image size is too Big"
                              : ""}
                          </span>
                        </label>
                        <input
                          type="file"
                          onChange={(e) => setImage(e.target.files[0])}
                        />
                      </div>
                      <div className="wrapper-data">
                        <label>Password</label>
                        <input
                          type="password"
                          name="phone"
                          defaultValue={data?.password}
                          onChange={(e) =>
                            setAdd({ ...add, password: e.target.value })
                          }
                        />
                      </div>
                      <button onClick={() => updateMember()}>
                        Update User Mobile
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={
          title !== "Image size is too Big, Maximum size 1MB"
            ? handleNext
            : () => setModalShow(false)
        }
      />
    </div>
  );
}

export default Edituser;
